<template>
  <div class="bulidPlan">
    <div class="mainHeader">BIM4D</div>
    <div class="header">
      <el-button size="small" type="primary" @click="addPlanHandler">新建方案</el-button> 
      <el-input v-model="search" placeholder="请输入方案名称" size="small" @input="getTableData(1)" clearable ></el-input>
    </div>
    <div class="content">
      <el-table v-loading="loading" :data="plantable" :row-style="rowStyle" :header-cell-style="headerStyle"
        element-loading-text="数据加载中" height="100%"  >
        <template slot="empty">
          <img :src="zanwu" alt="暂无数据" />
          <p >暂无数据</p>
        </template>
        <el-table-column label="方案名称" min-width="200px" prop="programmeName" align="center">
          <template slot-scope="scope">
            <span @click="rowClick(scope.row)" class="pointer">{{scope.row.programmeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联模型节点" align="left" min-width="120px" prop="nodefolderName" />
        <el-table-column label="关联计划" align="left" min-width="200px" prop="conPlanName" />
        <el-table-column label="方案编制人" min-width="200px"  prop="programmeCreateUser" />
        <el-table-column label="创建时间" min-width="180" prop="programmeCreateDate" />
        <el-table-column label="操作" align="center" width="230px">
          <template #default="{ row }">
            <el-button type="text" class="operBtn" @click.stop="editorData(row)">编辑 </el-button>
            <el-button type="text" class="operBtn" @click.stop="deleteData(row)" >删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="getTableData" ></page>
    </div> -->
    <!-- 新增/编辑 -->
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :close-on-press-escape="false" width="600px" class="dialog">
      <el-form ref="planForm" :model="planForm" :rules="rules" >
        <el-form-item label="方案名称:" prop="programmeName">
          <el-input v-model="planForm.programmeName" placeholder="请输入方案名称" maxlength="15" show-word-limit size="small" clearable/>
        </el-form-item>
        <el-form-item  label="请选择关联的施工计划:" prop="conPlanId">
          <el-select v-model="planForm.conPlanId" placeholder="请选择" style="width:100%" size="small" clearable filterable>
            <el-option v-for="item in options" :key="item.value" :label="item.conPlanName" :value="item.conPlanId" placeholder="请选择关联计划"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div  class="treeTitle">关联节点 </div>
      <el-tree :data="treeList" :props="defaultProps" default-expand-all :expand-on-click-node="false" 
        node-key="folderId" ref="tree" :highlight-current="true" class="diaTree"  @current-change="currentOrgChangeHandler"
        >
        <template #default="{ data }">
          <div class="treeContent">
           <img :src="stageImg"  alt="阶段图片" v-if="data.folderType=='2'" class="imgCont"/>
              <img :src="classImg"  alt="分类图片" v-else-if="data.folderType=='0'" class="imgCont"/>
              <img :src="nodeImg"  alt="节点图片" v-else-if="data.folderType=='1'" class="imgCont"/>
            <span style="font-size:14px">{{ data.folderName }}</span>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelHander">取 消</el-button>
        <el-button  type="primary" @click="addHander(submitType)">确 定</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import page from '@/CommonDP/components/paging'
import bimService from "@/xgzdService/buildPlan-service"
import bimManage from "@/xgzdService/bimManage-service"
import bimFour from "@/xgzdService/bimFour-service"
import { mapState } from 'vuex'
const newModuleForm = ({
  programmeName,//方案名称
  conPlanId,//关联计划id
  conPlanName,//关联计划
  nodefolderName,//关联节点
  nodefolderId,//关联节点id
  programmeId,
} = {}) => {
  return {
    programmeName: programmeName || "",
    conPlanId:conPlanId||"",
    conPlanName:conPlanName||"",
    nodefolderName: nodefolderName || "",
    nodefolderId:nodefolderId||"",
    programmeId:programmeId||"",
    folderType:"1"
  };
};
export default {
  components: { page },
  data(){
    return{
      search:"",
      plantable:[ ],
      loading:false,
      zanwu: require('@/CommonDP/assets/暂无数据.png'),
      page: {
        pageNum: 1,
        pageSize: 10,
        totalCount: 0
      },
      dialogVisible:false,
      planForm:{
        programmeName:"",conPlanId:"",conPlanName:"",nodefolderId:'',nodefolderName:"",folderType:""
      },
      submitType:"",
      rules:{
        programmeName:[{ required: true, message: '请输入方案名称', trigger: 'blur' },],
        conPlanId:[{ required: true, message: '请选择计划', trigger: 'change' }],
      },
      options:[ ],
      defaultProps: {
        children: 'childList',
        label: 'folderName'
      },
      treeList:[],
      stageImg:require(`@/views/assets/stage.png`),
      nodeImg:require(`@/views/assets/node.png`),
      classImg:require(`@/views/assets/class.png`),
      editForm:{}
    }
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
    }),
    dialogTitle(){
      return ["新建方案名称","编辑方案名称"][this.submitType]
    }
  },
  created() {
    this.getTableData(1)
  },
  methods:{
    async getTableData(index) {
      this.loading = true
      const { search, enterpriseId, page: { pageSize } ,prjInfo:{prjId}} = this;
      const params = {
        programmeName: search,
        pageSize,
        pageNum: index,
        enterpriseId,
        prjId
      }
      const { data, totalCount, pageNum } = await bimFour.getProgramme(prjId,enterpriseId,search)
      this.page.totalCount = totalCount
      this.page.pageNum = pageNum
      this.plantable = data
      this.loading = false
    },
    // 添加方案
    async addPlanHandler(moduleForm = {}) {
      this.planForm = newModuleForm(moduleForm);
      this.dialogVisible=true;
      this.submitType=0;
      this.getPlan();
      this.getTreeList();
      await this.$nextTick();
      this.$refs.planForm.clearValidate();
    },
    cancelHander(){
      this.dialogVisible=false;
      this.$refs.planForm.clearValidate();
      this.$nextTick(()=>{
         this.$refs.planForm.resetFields();
         this.planForm.nodefolderName="";
         this.getTableData(1)
      })
    },
    currentOrgChangeHandler(val){
      this.planForm.folderType=val.folderType;
      this.planForm.nodefolderName=val.folderName;
      this.planForm.nodefolderId=val.folderId;
    },
    async addHander(submitType){
      await this.$refs.planForm.validate();
      const{ planForm:{ programmeName,folderType,nodefolderId ,programmeId,conPlanId}, enterpriseId, prjInfo:{prjId} }=this;
      if(!nodefolderId||folderType!="1") {
        this.$message.warning("请选择关联的节点")
        return
      };
      const params={
         enterpriseId,
         prjId,
         programmeName,
         conPlanId,
         nodefolderId
      };
      if(submitType===0)await bimFour.addProgramme(params),
      await this.$message.success("添加成功");
      else {
        params.programmeId=programmeId;
        await bimFour.updateProgramme(params);
        await this.$message.success("修改成功");
      }
      this.cancelHander()
    },
    async editorData(row){
      this.planForm=newModuleForm(row);
      this.dialogVisible=true;
      this.submitType=1;
      await this.getPlan();
      await this.getTreeList();
      await this.$nextTick();
      this.$refs.planForm.clearValidate();
    },
    deleteData(row){
      this.$confirm(`确定删除方案名称 ${row.programmeName}?`, '警告', { type: 'warning', })
      .then(() => bimFour.delProgramme(row.programmeId))
      .then(() => { this.$message({ type: 'success', message: '删除方案成功' }) })
      .then(() => { this.getTableData(1) });
    },
    async getPlan() {
      const { enterpriseId,prjInfo:{prjId} } = this;
      const params = {
        pageSize:100000,
        pageNum: 1,
        enterpriseId,
        prjId
      }
      const { data } = await bimService.getConstructionPlan(params)
      this.options = data
    },
    async getTreeList(){
      const{prjInfo:{prjId},enterpriseId}=this;
      const {data}=await bimManage.getFolderTree(prjId,enterpriseId);
      this.treeList=data.map((item)=>{
        if(item.parentId==="0")  item.folderType = "2"
        return item
      });;
    },
    rowClick(rows){
      const fileIds = rows.modelVos.map((item) => item.modeId).join();
      const fileNames = rows.modelVos.map((item) => item.modeName).join();
      const rvtVersion = rows.modelVos.map((item) => item.modelFileVersion).join();
      const {prjId,prjName}=this.prjInfo;
      const { href } = this.$router.resolve({ path: "/bimPreview" ,query: { fileIds, fileNames, prjId, prjName, rvtVersion,conPlanId:rows.conPlanId} });
      window.open(href, "_blank");
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getTableData(1)
    },
    rowStyle() {
      return 'height:60px'
    },
    headerStyle() {
      return 'background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9'
    }
  }
}
</script>

<style lang="scss" scoped>
.bulidPlan{
  width: 100%;
  height: 100%;
  background :#fff;
  position: relative;
  .mainHeader {
    width: 100%;
    height: 50px;
    padding-left: 30px;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
  }
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 30px;
    .el-input{
      width: 200px;
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }
  .content {
    position: absolute;
    top: 105px;
    left: 30px;
    right: 30px;
    bottom: 40px;
  }
  .footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px;
  }
  .dialog{
    /deep/.el-dialog__body{
      height: 500px;
      overflow: auto;
      position: relative;
      padding:20px 28px!important;
    }
    .treeContent{
      display:flex;
      align-items:center;
      .el-icon-circle-plus{
        margin-left: 20px;
        font-size: 16px;
      }
      .imgCont{
        margin-right: 6px;
      }
    }
    .diaTree{
      margin-top:10px
    }
    .el-form-item:last-child{
      margin-bottom: 5px;
    }
    .el-form-item__error{
      top: 85px;
    }
    /deep/.el-form-item__content{
      line-height: 30px;
    }
    .treeTitle{
      font-weight: 400;
      font-size: 15px;
      color: #000;
      margin-top:20px
    }
  }
  .pointer{
    cursor: pointer;
  }
}
</style>